<template>
  <div class="all-consent-bar" :class="{ reverse: settings.reverseAllConsentButtonsOrder == 1 }">
    <button
      v-if="!settings.hideAcceptAll"
      role="button"
      type="button"
      class="btn accept-all"
      @click="handleConsentAction(true)"
      @keydown.space.prevent="handleConsentAction(true)"
      @keydown.enter="handleConsentAction(true)"
      :style="acceptAllStyle"
      :aria-label="$t('acceptAllAria')"
      :title="$t('acceptAllAria')"
      v-safe-html="settings.acceptAllText || $t('acceptAll')"
    ></button>
    <button
      v-if="!settings.hideRefuseAll"
      role="button"
      type="button"
      class="btn refuse-all"
      @click="handleConsentAction(false)"
      @keydown.space.prevent="handleConsentAction(false)"
      @keydown.enter="handleConsentAction(false)"
      :style="refuseAllStyle"
      :aria-label="$t('refuseAllAria')"
      :title="$t('refuseAllAria')"
      v-safe-html="settings.refuseAllText || $t('refuseAll')"
    ></button>
    <div aria-live="polite" class="sr-only">{{ lastActionMessage }}</div>
  </div>
</template>
<script>
import { i18nMixin } from 'shared/i18n/i18n-mixin';

export default {
  mixins: [i18nMixin],
  props: {
    settings: {
      type: Object,
      required: true,
    },
    useStyleAttr: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      lastActionMessage: '',
    };
  },
  methods: {
    handleConsentAction(isAccepted) {
      this.updateActionMessage(isAccepted);
      this.$emit('click', isAccepted);
    },
    updateActionMessage(isAccepted) {
      this.lastActionMessage = isAccepted
        ? this.$t('allCookiesHaveBeenAccepted')
        : this.$t('allCookiesHaveBeenRefused');
    },
  },
  computed: {
    acceptAllStyle() {
      if (this.useStyleAttr) {
        return { background: this.settings.acceptAllBgColor, color: this.settings.acceptAllTextColor };
      } else {
        return null;
      }
    },
    refuseAllStyle() {
      if (this.useStyleAttr) {
        return { background: this.settings.refuseAllBgColor, color: this.settings.refuseAllTextColor };
      } else {
        return null;
      }
    },
  },
};
</script>
<style lang="less">
.all-consent-bar {
  display: flex;
  flex-direction: row;
  &.reverse {
    flex-direction: row-reverse;
  }
  button {
    margin-right: 3px;
  }
}
</style>
